import React from 'react'
import SectionA from './Comp/SectionA/SectionA'
import Hero from './Comp/Hero/Hero'
import Slider from './Comp/Slider/Slider'
import SEO from '../../../seo/SEO'
import { SITE_URL } from '../../../seo/config'

export default function Testimonials() {
    const organization = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Fuel Clubs",
        "url": SITE_URL,
        "logo": `${SITE_URL}/logo.png`
    };

    const testimonialsPage = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "FuelClubs Reviews & Testimonials",
        "url": `${SITE_URL}/testimonials`,
        "description":
            "Read real reviews and testimonials from FuelClubs customers in Las Vegas and Henderson who trust our on-demand fuel delivery for their vehicles, fleets, and equipment."
    };

    return (
        <>
            <SEO
                title="FuelClubs Reviews & Testimonials | Mobile Fuel Delivery in Las Vegas"
                description="See what FuelClubs customers in Las Vegas and Henderson are saying about our convenient, reliable on-demand fuel delivery service."
                keywords={[
                    'FuelClubs reviews',
                    'FuelClubs testimonials',
                    'fuel delivery reviews Las Vegas',
                    'mobile gas delivery testimonials',
                    'on-demand fuel customer stories'
                ]}
                robots="index, follow"
                canonical="/testimonials"
                image="/logo.png"
                type="website"
                structuredData={[organization, testimonialsPage]}
            />

            <SectionA />
            <Hero />
            <Slider />
        </>
    )
}
